import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { inject } from '@angular/core';
import { HomeComponent } from './pages/home/home.component';
import { ErrorPageComponent } from './core/components/error-page/error-page.component';
import { AppService } from './service/app.service';
import { UnauthorizedComponent } from './core/components/unauthorized-page/unauthorized-page.component';
import { DettaglioEnteComponent } from './pages/dettaglio-ente/dettaglio-ente.component';
import { EnteComponent } from './pages/ente/ente.component';
import { UtentiMasterComponent } from './pages/utenti-master/utenti-master.component';
import { EntiResolver } from './pages/anagrafica-ente/enti.resolver';
import { DettaglioEnteResolver } from './pages/dettaglio-ente/dettaglio-ente.resolver';
import { UtentiMasterResolver } from './pages/utenti-master/utenti-master.resolver';
import { UtentiApplicativiComponent } from './pages/utenti-applicativi/utenti-applicativi.component';
import { UtentiApplicativiResolver } from './pages/utenti-applicativi/utenti-applicativi.resolver';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { InformativaPrivacyComponent } from './pages/privacy/informativa-privacy.component';

const RedirectRules: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router: Router = inject(Router);

  const userEnabled: boolean =
    inject(AppService).user.isUtenteAbilitato ?? false;
  const userSecurity: boolean = inject(AppService).user.isUtenteAdmin ?? false;
  const flagPrivacy: boolean = inject(AppService).user.flagPrivacy ?? false;
  const idEnte: string = inject(AppService).user.idEnte?.toString() ?? '';

  const urlRequestHome = state.url == '/home';
  const urlRequestUnauthorized = state.url == '/unauthorized';
  const urlRequestErrorPage = state.url == '/error-page';
  const urlRequestEnte = state.url == '/ente';
  const urlRequestPrivacy = state.url == '/privacy';

  if (userSecurity) {
    //Utente security manager
    if (urlRequestErrorPage || urlRequestUnauthorized || urlRequestPrivacy) {
      router.navigate(['home']);
      return false;
    }
    if (urlRequestHome) {
      return true;
    }
  } else if (userEnabled && idEnte != '') {
    //Utente master
    if (urlRequestPrivacy) {
      if (flagPrivacy) {
        router.navigate(['ente']);
        return false;
      }
      return true;
    }
    if (urlRequestHome || urlRequestErrorPage || urlRequestUnauthorized) {
      router.navigate(['ente']);
      return false;
    }
    if (urlRequestEnte) {
      if (!flagPrivacy) {
        router.navigate(['privacy']);
        return false;
      }
      return true;
    }
  } else {
    if (urlRequestHome || urlRequestEnte || urlRequestErrorPage) {
      router.navigate(['unauthorized']);
      return false;
    }
    if (urlRequestUnauthorized) {
      return true;
    }
  }
  return true;
};

const EnteRules: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router: Router = inject(Router);
  const enteExists = inject(AppService).ente.idEnte ?? null;
  const flagPrivacy = inject(AppService).user.flagPrivacy ?? false;
  const userSecurity: boolean = inject(AppService).user.isUtenteAdmin ?? false;
  if (!enteExists) {
    router.navigate(['home']);
    return false;
  } else if (!flagPrivacy && !userSecurity) {
    router.navigate(['privacy']);
    return false;
  }
  return true;
};

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    canActivate: [],
    canActivateChild: [MsalGuard, RedirectRules],
    children: [
      {
        path: 'home',
        component: HomeComponent,
        resolve: { data: EntiResolver }
      },
      {
        path: 'ente',
        component: EnteComponent,
        canActivate: [EnteRules],
      },
      {
        path: 'dettaglio-ente',
        component: DettaglioEnteComponent,
        canActivate: [EnteRules],
        resolve: { data: DettaglioEnteResolver }

      },
      {
        path: 'utenti-master',
        component: UtentiMasterComponent,
        canActivate: [EnteRules],
        resolve: { data: UtentiMasterResolver }
      },
      {
        path: 'utenti-applicativi',
        component: UtentiApplicativiComponent,
        canActivate: [EnteRules],
        resolve: { data: UtentiApplicativiResolver }
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
      }
    ],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [RedirectRules],
  },
  { path: 'informativa-privacy', component: InformativaPrivacyComponent, pathMatch: 'full' },
  { path: 'error-page', component: ErrorPageComponent, pathMatch: 'full' },
  { path: '**', pathMatch: 'full', redirectTo: '/error-page' },
];
